import { LEFT_RAIL_STATIC_WIDTH } from '../internalConstants';
import { isLeftRailVisible } from 'owa-left-rail';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

/**
 * Gets the current padding left of search box.
 * @returns the number of pixels
 */
export default function getSearchBoxLeftPadding(): number {
    // If left rail is visible, align to nav bar width, otherwise align to nav bar width + left rail
    const navBarWidth = getUserConfiguration().UserOptions.NavigationBarWidth;
    return !isLeftRailVisible() ? navBarWidth : navBarWidth + LEFT_RAIL_STATIC_WIDTH;
}
